var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtocols(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-whales"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6485 2.23438H4.35782C3.75462 2.23438 3.26562 2.67159 3.26562 3.21093V20.7888C3.26562 21.3282 3.75462 21.7654 4.35782 21.7654H19.6485C20.2518 21.7654 20.7407 21.3282 20.7407 20.7888V3.21093C20.7407 2.67159 20.2518 2.23438 19.6485 2.23438Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.375 2.23438H12.0008V10.458L9.68788 8.40206L7.375 10.458V2.23438Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0547 17.6523H17.1385",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 14.5703L17.1397 14.5703",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocols);
export default __webpack_public_path__ + "static/media/protocols.18afa433a95a0718d80c212ed52c5e69.svg";
export { ForwardRef as ReactComponent };